import styled from '@emotion/styled';
import { SvgIcon, SvgNames, tokens } from '@sunrun/experience-ui-components';
import type { ReactNode } from 'react';
// eslint-disable-next-line import/no-restricted-paths
import { InfoPopover } from 'components/atoms/InfoPopover';

type WarningIconPopoverProps = {
  content: ReactNode;
  contentAriaLabel: string;
  triggerAriaLabel: string;
  contentTestId?: string;
  iconSize?: number;
  iconColor?: string;
};

const WarningIconPopover = ({
  content,
  contentAriaLabel,
  triggerAriaLabel,
  contentTestId,
  iconSize = 18,
  iconColor = tokens.WARNING_20,
}: WarningIconPopoverProps) => (
  <InfoPopover
    content={content}
    contentAriaLabel={contentAriaLabel}
    contentTestId={contentTestId}>
    <WarningTriggerButton
      type="button"
      aria-label={triggerAriaLabel}
      data-testid="list-view-truncation-warning">
      <SvgIcon
        name={SvgNames.WarningFilled}
        width={iconSize}
        height={iconSize}
        color={iconColor}
      />
    </WarningTriggerButton>
  </InfoPopover>
);

const WarningTriggerButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  line-height: 0;
  border-radius: 50%;
  flex-shrink: 0;

  &:focus-visible {
    outline: 2px solid ${tokens.HEROBLUE_50};
    outline-offset: 2px;
  }
`;

export { WarningIconPopover };
